module.exports = __webpack_public_path__ + "img/lieferando-de.a3517e84.png";